import React from 'react';
import { bool } from 'prop-types';
import FooterItem from './footer-item/FooterItemContainer';
import SocialMedias from './social-medias/SocialMedias';
import './Footer.css';


function Footer({ marginTop }) {
  return (
    <footer className="footer" style={{ margin: marginTop ? '' : 'unset' }}>
      <div className="wrapper">
        <ul className="footer-list">
          <FooterItem
            link="https://ajuda.olx.com.br/s/"
            classLink="socialMedias-item-link"
            className="footer-list-item"
            text="Ajuda e contato"
          />

          <FooterItem
            link="https://ajuda.olx.com.br/s/"
            classLink="socialMedias-item-link"
            className="footer-list-item"
            text="Dicas para negociação"
          />

        </ul>
        <SocialMedias />

        <ul className="footer-info">
          <FooterItem
            link="https://ajuda.olx.com.br/s/"
            classLink="socialMedias-item-link"
            className="footer-info-item"
            text="Sobre a OLX,"
          />

          <FooterItem
            link="https://ajuda.olx.com.br/s/article/termos-e-condicoes-de-uso"
            classLink="socialMedias-item-link"
            className="footer-info-item"
            text="Termos de uso"
          />

          <FooterItem
            link="https://ajuda.olx.com.br/s/"
            className="footer-info-item"
            text="e"
          />

          <FooterItem
            link="https://ajuda.olx.com.br/s/article/politica-de-privacidade"
            classLink="socialMedias-item-link"
            className="footer-info-item"
            text="Politica de privacidade"
          />
          <p className="footer-info-item footer-info-item_block">© Bom Negócio Atividades de Internet Ltda. Rua do Catete, 359, Flamengo - 22220-001 - Rio de Janeiro, RJ</p>
        </ul>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  marginTop: bool.isRequired,
};

export default Footer;
